import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxDropdown } from "@axess/limestone";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxAlert } from "../../Limestone/AxAlert/AxAlert";
import { inputMaskHelper } from '../../Lib/Helper/InputMaskHelper';

@ModuleName("FindMyTicket")
export class FindMyTicket implements AxInit {
    private cardSelection: AxDropdown = new AxDropdown();
    private currentWtp: string;

    //private currentSelection: selectionReturn;

    private keyList = {
        listClass: '.findMyTickets__ticketList',
        detailClass: '.findMyTickets__details',
        searchClass: '.findMyTickets__input-search',
        formAssistantClass: '.findMyTickets__wrapper .ax-form-group-assistence'
    };

    constructor(private _i18nHelper = new I18nHelper()) { }

    AxInit(init): void {
        this.cardSelection.init('.findMyTickets__wrapper .ax-dropdown',
        {
            multiSelect: false,
            searchBar: false,
            onSelect: ($x, y) => {
                this.searchDropdown($x, y as string);
            }
        });

        $(this.keyList.searchClass).inputmask({
            mask: inputMaskHelper.wtpNumberMask(),
            ...inputMaskHelper.wtpMaskOptions()
        });

        $('input[name=findMyTickets__input-type]').change(x => {
            let target = $('input[name=findMyTickets__input-type]:checked').attr('data-target');
            $(`.findMyTickets__input-content > div`).removeClass('active');
            $(`.findMyTickets__input-content > div[data-target=${target}]`).addClass('active');

            $(this.keyList.listClass).addClass('d-none');
        });

        $('.findMyTickets__input-find-btn').click(x => {
            let target = $('input[name=findMyTickets__input-type]:checked').attr('data-target');

            if (target === '1') {
                if ($(this.keyList.listClass).html() === '') return;
                this.switchTab();
            } else {
                this.searchText(true);
            }
        });

        $(this.keyList.searchClass).keyup(x => {
            let $target = $(x.delegateTarget);
            let value = $target.val();
            $(this.keyList.searchClass).parent().removeClass('invalid-form');
            $(this.keyList.formAssistantClass).html('');

            $(this.keyList.searchClass).not($target).val(value);
        });

        $('.findMyTickets__input-btn').click(x => {
            this.searchText(false);
        });
    }

    searchText(mobileTriggered: boolean) {
        this.loadChipCardData($(this.keyList.searchClass).val() as string, mobileTriggered);
    }

    searchDropdown($parent: JQuery<HTMLElement>, value: string) {
        $(this.keyList.searchClass).val('');
        this.loadChipCardData(value, false);
    }

    loadChipCardData(wtpNr: string, mobileTriggered: boolean) {
        this.currentWtp = wtpNr;
        AxessViewer.loadPartialView('/FindMyTicket/_GetChipCard',
            {
                wtpNr: wtpNr
            },
            resp => {
                if (resp.success) {
                    $(this.keyList.detailClass).html('');
                    $(this.keyList.listClass).removeClass('d-none');
                    $(this.keyList.listClass).html(resp.view);
                    this.registerListEvents();

                    if (mobileTriggered) {
                        this.switchTab();
                    }
                } else {
                    $(this.keyList.searchClass).parent().addClass('invalid-form');
                    $(this.keyList.formAssistantClass).html(resp.message);
                }
            },
            { silent: true });
    }

    switchTab() {
        $('.findMyTickets__wrapper').toggleClass('d-none');
        $('.findMyTickets__result-wrapper').toggleClass('d-none');
    }

    registerListEvents() {
        $('.findMyTickets__list_return-btn').click(x => {
            this.switchTab();
        });

        $('.findMyTickets__ticketList-details').click(x => {
            let $target = $(x.delegateTarget);
            let data = {
                wtpNr: this.currentWtp,
                projNr: $target.attr('data-projNr'),
                posNr: $target.attr('data-posNr'),
                serialNr: $target.attr('data-serialNr'),
                validFrom: $target.attr('data-valid'),
            }

            AxessViewer.loadPartialView('/FindMyTicket/_Details',
                data,
                resp => {
                    $('body, main').addClass('ax-bg-white');
                    $(this.keyList.listClass).addClass('d-none');
                    $(this.keyList.detailClass).html(resp.view);
                    this.registerDetailEvents();
                },
                {});
        });
    }

    registerDetailEvents() {
        new AxAlert('.findMyTickets__details .ax-alert-banner');
        $('.findMyTickets__details-button').click(x => {
            $('body, main').removeClass('ax-bg-white');
            $(this.keyList.detailClass).html('');
            $(this.keyList.listClass).removeClass('d-none');
        });
    }
}